import React from 'react'
import { Nav, NavDropdown } from 'react-bootstrap'
import styles from '../Header.module.css'
import { Item } from '../Header'
import { features } from '../../../../constants/navMenus'
import useHoverDropdown from '../useHoverDropdown'

const FeaturesDropdown = () => {
  const hoverProps = useHoverDropdown()

  return (
    <Nav.Item className="integration-tab">
      <NavDropdown
        className="p-md-0 m-auto dropdown-toggle"
        title={
          <span className={styles.contentBoxNav}>
            <img src="/assets/icons/squares-four.svg" alt="Features" className={styles.img} />
            <span className={styles.contentText}>Features</span>
          </span>
        }
        variant="link"
        {...hoverProps}
      >
        <div className={`${styles.menu} ${styles.twoColumnMenu}`}>
          <div className={styles.contentContainer}>
            <div className={`${styles.twoColumn} ${styles.equalColumns}`}>
              {features.map(({ name, href, icon, description }) => (
                <Item
                  key={href}
                  icon={icon}
                  alt={name}
                  label={name}
                  href={href}
                  target="_blank"
                  subtitle={description}
                />
              ))}
            </div>
          </div>
        </div>
      </NavDropdown>
    </Nav.Item>
  )
}

export default FeaturesDropdown
